module.exports = {}


//////////////////
// WEBPACK FOOTER
// ./src/i18n/languages/ru.json
// module id = TpWN
// module chunks = 8